<template>
    <div
        v-if="isUserLoggedIn"
        uk-sticky="sel-target: .uk-navbar-container; cls-active: uk-navbar-sticky;"
    >
        <nav
            class="uk-padding-small uk-background-default"
            uk-navbar
        >
            <div class="uk-navbar-left">
                <router-link
                    to="/dashboard"
                    class="uk-navbar-item uk-logo"
                >
                    Customer Payments
                </router-link>
            </div>
            <div class="uk-navbar-right">
                <div
                    v-if="canUserAccessPayments"
                    class="uk-navbar-item uk-visible@m"
                >
                    <a
                        class="uk-button uk-button-primary"
                        @click="goToCreate()"
                    >
                        New payment
                    </a>
                </div>
                <div
                    v-if="canUserAccessPayments && isUserAdmin && isExportShown"
                    class="uk-navbar-item uk-visible@m"
                >
                    <router-link
                        to="/report"
                        class="uk-button uk-button-default"
                    >
                        Export Payments
                    </router-link>
                </div>
                <div
                    v-if="canUserAccessRefunds"
                    class="uk-navbar-item uk-visible@m"
                >
                    <router-link
                        to="/refund-requests"
                        class="uk-button uk-button-default"
                    >
                        Refund Requests
                    </router-link>
                </div>
                <div
                    v-show="showRefreshButton"
                    class="uk-navbar-item uk-visible@m"
                >
                    <a
                        class="uk-button uk-button-primary"
                        @click="refreshPage"
                    >
                        <span uk-icon="refresh"></span>
                    </a>
                </div>
                <button
                    v-if="isUserLoggedIn"
                    class="nav-menu uk-navbar-item uk-button uk-button-link"
                    uk-toggle="target: #menu"
                    type="button"
                >
                    <span
                        uk-icon="icon: menu"
                    />
                </button>
            </div>
        </nav>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import router from '../../helpers/router'

export default {
    name: 'NavbarComponent',
    data: function () {
        return {
            searchOpen: false
        }
    },
    computed: {
        ...mapGetters({
            user: 'user',
            isUserAdmin: 'isUserAdmin',
            activePage: 'activePage',
            isUserLoggedIn: 'isUserLoggedIn',
            serverTimezone: 'serverTimezone',
            canUserAccessPayments: 'canUserAccessPayments',
            canUserAccessRefunds: 'canUserAccessRefunds',
        }),
        isExportShown() {
            return (this.activePage !== 'create') && (this.activePage !== 'edit');
        },
        timezone() {
            return this.serverTimezone ? this.serverTimezone : 'local';
        },
        showRefreshButton() {
            return (this.$route.name !== 'Edit');
        }
    },
    methods: {
        ...mapActions({
            updateActivePage: 'updateActivePage',
            updateActivePaymentID: 'updateActivePaymentID'
        }),
        goToCreate() {
            router.replace('/create')
        },
        refreshPage() {
            window.location.reload();
        }
    }
}
</script>
